import { ColorOptions, convertHexToRGBA, ModBox, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { Routes } from '../../nav/routes'
import { Colors, dateFormatter, DateFormatTypes } from '../../util/util'

export const Header = ({ show, dateVal, type, path }) => {
  return (
    <ModBox
      flexDirection={'row'}
      align={'center'}
      bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
      ph={24}
      h={36}
      show={show}>
      <Text
        title={type}
        fontFamily={'JioType-Bold'}
        fontSize={12}
        lineHeight={16}
        letterSpacing={-0.06}
        color={'BLACK_75'}
        hide={isEmpty(type)}
      />
      <ModBox marginHorizontal={8} bg={'BLACK_75'} h={4} w={4} borderRadius={4} show={type?.length > 0} />
      <Text
        title={path === Routes.SETTLEMENTS ? dateVal : `${dateFormatter(dateVal, DateFormatTypes.DD_MMM_YYYY)}`}
        fontFamily={'JioType-Bold'}
        fontSize={12}
        lineHeight={16}
        letterSpacing={-0.06}
        color={'BLACK_75'}
      />
    </ModBox>
  )
}
